<div class="flex justify-between items-center mb-4">
  <h2 class="text-lg font-semibold">{{ 'SETUP.EMPLOYEE.TITLE' | translate }}</h2>

  <button class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg" (click)="openPopup()">
    {{ 'SETUP.EMPLOYEE.ADD_BUTTON' | translate }}
  </button>
</div>

<section class="p-4">
  <app-table
    [columns]="columns"
    [data]="employees"
    [actions]="actions"
    [enablePagination]="true"
    [pageSize]="10"
  >
  </app-table>

  @if (employees.length === 0) {
    <div class="text-center py-10 text-gray-400 bg-white border border-gray-200">
      {{ 'SETUP.EMPLOYEE.NO_EMPLOYEES_FOUND' | translate }}
    </div>
  }
</section>

<!-- ADD / EDIT / VIEW POPUP -->
<app-popup
  [(show)]="showPopup"
  [title]="isViewMode ? 'SETUP.EMPLOYEE.VIEW_EMPLOYEE' : (isEditMode ? 'SETUP.EMPLOYEE.EDIT_EMPLOYEE' : 'SETUP.EMPLOYEE.ADD_EMPLOYEE')"
  [fields]="fields"
  [data]="formData"
  [onSave]="handleSave"
  [readonly]="isViewMode"
  type="form">
</app-popup>

<!-- DELETE CONFIRMATION POPUP -->
<app-popup
  [(show)]="showDeletePopup"
  title="SETUP.EMPLOYEE.DELETE_EMPLOYEE"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()">
</app-popup>